import { createElement } from 'react';
import cn from '../List.css.json';
import '../List.css';

export const ListSeparator = () => <li role="separator" className={cn.itemSeparator} />;
